import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoveRight1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "move-right-1" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18.75,
			y1: 11.998,
			x2: .75,
			y2: 11.998
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "15 8.248 18.75 11.998 15 15.748"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 23.25,
			y1: .748,
			x2: 23.25,
			y2: 23.248
		})
	]
});
export default SvgMoveRight1;
